<div class="container my-4" #top>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header" >
          <h1>Mappa del sito</h1>
        </div>
        <div class="progress progress-indeterminate" *ngIf="urls.length === 0">
          <span class="visually-hidden">In elaborazione...</span>
          <div class="progress-bar" role="progressbar"></div>
        </div>
        <div class="card-body" *ngIf="urls.length > 0">
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">URL</th>
                  <th scope="col">Ultima modifica</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let url of urls">
                  <td>
                    <a [href]="url.loc" target="_blank" class="text-primary">
                      {{ url.loc }}
                    </a>
                  </td>
                  <td>{{ url.lastmod || 'Non disponibile' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Bootstrap Italia Pagination -->
          <nav aria-label="Navigazione della sitemap">
            <ul class="pagination justify-content-center">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(currentPage - 1)" aria-label="Precedente">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Precedente</span>
                </a>
              </li>
              <li 
                *ngFor="let page of [].constructor(totalPages); let i = index" 
                class="page-item" 
                [class.active]="currentPage === i + 1"
              >
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(i + 1)">
                  {{ i + 1 }}
                </a>
              </li>
              <li class="page-item" [class.disabled]="currentPage === totalPages" *ngIf="totalPages > 1">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(currentPage + 1)" aria-label="Successivo">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Successivo</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>